import { ImageWithFallback } from "./ImageWithFallback";
import iphoneCentered from "../../assets/landing/uae-1.jpg";

const AppleStoreIcon = () => (
  <svg viewBox="0 0 24 24" className="lp-w-8 lp-h-8 lp-text-dark" fill="currentColor">
    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
  </svg>
);

const PlayStoreIcon = () => (
  <svg viewBox="0 0 24 24" className="lp-w-8 lp-h-8 lp-text-dark" fill="currentColor">
    <path d="M3.18 23.76c.3.17.64.24.99.19l12.81-12.08-2.81-2.81L3.18 23.76zM22.03 10.06l-2.89-1.67-3.15 2.97 3.15 2.97 2.91-1.69c.83-.48.83-1.62-.02-2.58zM1.55.36C1.21.54 1 .91 1 1.35v21.3c0 .44.21.81.55.99l12.81-12.08L1.55.36zM14.27 12.56l2.81-2.81L4.27.67c-.36-.21-.73-.22-1.05-.06L14.27 12.56z" />
  </svg>
);

export function LandingAppDownload() {
  return (
    <section id="download" className="lp-py-16 lp-px-6 lp-relative lp-overflow-hidden">
      {/* Background glow circle */}
      <div
        aria-hidden
        className="lp-absolute lp-left-half lp-tx-neg-half lp-pointer-none lp-op-10"
        style={{
          bottom: "-150px",
          width: 600,
          height: 600,
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(74, 158, 255, 0.2) 0%, transparent 70%)",
        }}
      />

      <div className="lp-max-6xl lp-mx-auto lp-text-center lp-relative lp-z-10">
        
        <p
          className="lp-text-blue lp-text-xs lp-uppercase lp-tracking-wide lp-mb-4"
          style={{ fontFamily: "'Outfit', sans-serif" }}
        >
          Download HubScroll
        </p>
        
        <h2
          className="lp-text-dark lp-mb-6 lp-max-2xl lp-mx-auto"
          style={{
            fontFamily: "'Fraunces', serif",
            fontWeight: 600,
            letterSpacing: "-0.025em",
            fontSize: "clamp(2rem, 5vw, 3.5rem)",
            lineHeight: 1.1,
          }}
        >
          Your Next Favorite Place Is Just One Scroll Away
        </h2>
        
        <p
          className="lp-text-muted lp-mb-10 lp-leading-relaxed lp-max-xl lp-mx-auto"
          style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 300, fontSize: "1.05rem" }}
        >
          Download HubScroll today and start discovering the best cafés, restaurants, and nightlife venues across Dubai and the UAE.
        </p>

        {/* Store badge download row */}
        <div className="lp-flex lp-flex-col sm-flex-row lp-gap-4 lp-justify-center lp-items-center lp-mb-16">
          {/* App Store */}
          <a
            href="#download"
            className="lp-flex lp-items-center lp-gap-35 lp-px-6 lp-py-3 lp-r-2xl lp-bg-surface lp-border lp-bc-b08 lp-transition lp-hov-scale"
            style={{ width: "220px" }}
          >
            <AppleStoreIcon />
            <div className="lp-text-left">
              <div className="lp-text-xs lp-text-muted lp-leading-none lp-mb-1" style={{ fontFamily: "'Outfit', sans-serif" }}>
                Download on the
              </div>
              <div className="lp-text-dark lp-leading-tight lp-font-medium" style={{ fontFamily: "'Outfit', sans-serif" }}>
                App Store
              </div>
            </div>
          </a>

          {/* Play Store */}
          <a
            href="#download"
            className="lp-flex lp-items-center lp-gap-35 lp-px-6 lp-py-3 lp-r-2xl lp-bg-surface lp-border lp-bc-b08 lp-transition lp-hov-scale"
            style={{ width: "220px" }}
          >
            <PlayStoreIcon />
            <div className="lp-text-left">
              <div className="lp-text-xs lp-text-muted lp-leading-none lp-mb-1" style={{ fontFamily: "'Outfit', sans-serif" }}>
                GET IT ON
              </div>
              <div className="lp-text-dark lp-leading-tight lp-font-medium" style={{ fontFamily: "'Outfit', sans-serif" }}>
                Google Play
              </div>
            </div>
          </a>
        </div>

        {/* Centered Large Phone Mockup */}
        <div className="lp-flex lp-justify-center">
          <div 
            className="lp-relative lp-drop-blue"
            style={{
              width: "280px",
              transform: "translateY(50px)",
              transition: "transform 0.5s ease",
            }}
          >
            <ImageWithFallback
              src={iphoneCentered}
              alt="HubScroll mobile mockup screen showcase"
              className="lp-w-full lp-r-36"
              style={{ border: "4px solid rgba(255,255,255,0.08)", boxShadow: "0 30px 70px rgba(0,0,0,0.6)" }}
            />
          </div>
        </div>

      </div>
    </section>
  );
}
